module.exports = __webpack_public_path__ + "static/media/american-exp-payment-wv.4f3c5f2f.svg";